import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex);

let currAccountIndex = localStorage.getItem('j-currAccountIndex');
if (currAccountIndex == null) {
    const accountList = JSON.parse(localStorage.getItem('j-accountList'));
    if (accountList) {
        currAccountIndex = 0;
    }
} else {
    currAccountIndex = parseInt(currAccountIndex, 10);
}

const debug = process.env.NODE_ENV !== 'production';
let session = localStorage.getItem('session');
if (session) {
    session = JSON.parse(session);
} else {
    session = {};
}
const userToken = session ? session.token : '';
const email = session ? session.email : '';
const bttUserid = session ? session.bttUserid : '';

const state = {
    socket: {
        isConnected: false,
        message: '',
        close: false,
        error: false,
        reconnectError: false,
    },

    cashWebSocketStatus: 0,
    depthWebSocketStatus: 0,
    todayWebSocketStatus: 0,
    dealWebSocketStatus: 0,
    cancelAssetWebSocketStatus: 0,
    orderWebSocketStatus: 0,
    cancelDepthStatus: 0,
    cancelDealStatus: 0,
    newMarketData: [],
    newOrder: [],
    newAssetData: [],
    assetWebScokcetStatus: 0,
    signStatus: 0,
    balances: [],
    assetQueryStatus: 0,
    newDeal: [],
    newDepth: [],
    user: JSON.parse(localStorage.getItem('session')) || {},
    priceUSD: {},
    priceCNY: {},
    accountList: JSON.parse(localStorage.getItem('j-accountList')) || null,
    currAccountIndex,
    inviterNotExist: false,
    isShowGenerate: false,
    introOrder: false,
    introUser: false,
    email,
    session,
    bttUserid,
    userToken,
    confirmStatus: false,

};


export default new Vuex.Store({
    state,
    mutations,
    actions: {
        sendMessage(context, message) {
            Vue.prototype.$socket.send(message);
        },
    },
    getters,
    strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js